import React, { useState } from 'react';
import { Button } from 'antd';

interface CheckoutCtaButtonProps {
  sessionId: string;
  expiresAt?: string;
  /** Runs the single web checkout handler (→ /checkout/<uuid>). */
  onCheckout: (sessionId: string) => Promise<void>;
  label?: string;
}

/**
 * Structured "Complete booking" CTA rendered from the generate_checkout_url
 * sideband (message.checkoutReady) — the reliable checkout entry point that
 * replaces scraping a markdown link out of the LLM's prose. Tapping it builds
 * the V2 cart on the BE and lands the user on /checkout/<uuid>.
 */
const CheckoutCtaButton: React.FC<CheckoutCtaButtonProps> = ({
  sessionId,
  expiresAt,
  onCheckout,
  label,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await onCheckout(sessionId);
    } finally {
      setLoading(false);
    }
  };

  const expiryLabel = (() => {
    if (!expiresAt) return null;
    const d = new Date(expiresAt);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  })();

  return (
    <div className="bot-checkout-cta">
      <Button
        type="primary"
        block
        className="btn-style-5"
        loading={loading}
        onClick={handleClick}
      >
        {label ?? 'Complete booking'}
      </Button>
      {expiryLabel && (
        <div className="bot-checkout-cta__expiry">
          {`Valid until ${expiryLabel}`}
        </div>
      )}
    </div>
  );
};

export default CheckoutCtaButton;
